/** Firestore 구독 카테고리 (장비 타입 무관, 항상 전체 구독) */
export const deviceFirestoreCategories = [
  'sensors',
  'managements',
  'control',
  'kpi',
];

/** Router 장비 상세·SmartFarm */
export const routerDetailGetDataConfig = {
  kpi: [],
};

/** 장비 상세 BigQuery 초기 조회 (deviceStore.getBigqueryDeviceDetailData) */
export const deviceDetailGetDataConfigByType = {
  'three-phase-solar': {
    sensors: [
      {
        statDate: { type: 'current' },
        endDate: { type: 'current' },
        parameter: 'PVV,PVA,PVW,RSV,STV,TRV,RA,SA,TA,CVI,PF,Freq,AGE,DGE,EFF',
        period: 5,
        processType: 'apexChart',
        limit: 13,
        sortType: 'desc',
        includeNull: false,
        reverse: true,
      },
      {
        statDate: { type: 'current', format: 'T00:00' },
        endDate: { type: 'd+1', format: 'T00:00' },
        parameter: 'PVV,PVA,PVW,AGE,CVI',
        period: 10,
        processType: 'apexChart',
        limit: null,
        sortType: 'asc',
        includeNull: true,
        reverse: false,
      },
      {
        statDate: { type: 'start' },
        endDate: { type: 'end' },
        parameter: 'PGE',
        period: 'day',
        processType: 'apexChart',
        limit: 31,
        sortType: 'asc',
        includeNull: true,
        reverse: false,
      },
      {
        statDate: { type: 'start' },
        endDate: { type: 'end' },
        parameter: 'PGE',
        period: 'month',
        processType: 'apexChart',
        limit: 1,
        sortType: 'asc',
        includeNull: true,
        reverse: false,
      },
    ],
  },
  'temperature-controller': {
    sensors: [
      {
        statDate: { type: 'start' },
        endDate: { type: 'end' },
        parameter:
          'CUMC,CUMT,D1,D2,DSP,RLCOMP,RLFAN,RLDEF,RLAUX,S1,S2,S3,S4',
        period: 1,
        processType: 'apexChart',
        limit: null,
        sortType: 'desc',
        includeNull: false,
        reverse: true,
      },
    ],
    managements: [
      {
        statDate: { type: 'start' },
        endDate: { type: 'end' },
        parameter: 'commStat',
        period: 1,
        processType: 'apexChart',
        limit: null,
        sortType: 'desc',
        includeNull: false,
        reverse: true,
      },
    ],
  },
};

/**
 * managements ProgressBar label/title — API 미제공 시 useDeviceKeyMeta 폴백
 * sensors 메타는 getDeviceLabelApi 단일 출처
 */
export const deviceManagementParameterByType = {
  'three-phase-solar': {
    Status: {
      title: '현재 상태 알림',
    },
    commStat: {
      title: '인버터 통신 상태',
      label: ['에러', '정상'],
    },
    LineStat: {
      title: '계통 상태',
      label: ['정상', '에러'],
    },
    InvPow: {
      title: '인버터 가동 상태',
      label: ['가동중', '정지'],
    },
    InvSafety: {
      title: '인버터 Safety 보호 회로',
    },
  },
  'temperature-controller': {
    Status: {
      title: '현재 상태 알림',
    },
    ConnStat: {
      title: '인버터 통신 상태',
      label: ['정상', '에러'],
    },
    LineStat: {
      title: '계통 이상 상태',
      label: ['정상', '에러'],
    },
    InvPow: {
      title: '인버터 가동 상태',
      label: ['가동중', '정지'],
    },
    InvSafety: {
      title: '인버터 Safety 보호 회로',
    },
  },
};

/** 현황판 deviceDrawingStore — outputNeedCalc BigQuery 키별 설정 */
export const GetDataConfig = {
  default: {
    TW: {
      statDate: { type: 'todayStart' },
      endDate: { type: 'todayEnd' },
      parameter: 'TW',
      period: 'day',
      processType: 'apexChart',
      limit: 31,
      sortType: 'asc',
      includeNull: true,
      reverse: false,
    },
  },
  'three-phase-solar': {
    EFF: {
      statDate: { type: 'current' },
      endDate: { type: 'current' },
      parameter: 'EFF',
      period: 1,
      processType: 'apexChart',
      limit: 1,
      sortType: 'desc',
      includeNull: false,
      reverse: true,
    },
    DGE: {
      statDate: { type: 'start' },
      endDate: { type: 'end' },
      parameter: 'PGE',
      period: 'day',
      processType: 'apexChart',
      limit: 31,
      sortType: 'asc',
      includeNull: true,
      reverse: false,
    },
  },
  'temperature-controller': {
    sensors: [],
  },
  thermohygrometer: {
    sensors: [],
  },
  router: {
    sensors: [],
    managements: [],
    control: [],
    kpi: [],
  },
  fs600r: {
    sensors: [],
  },
  NMC: {
    sensors: [],
  },
  'MKR-3': {
    sensors: [],
  },
};

